/* eslint-disable import/prefer-default-export */
import { gql } from "@apollo/client";


export const DELETE_REVIEW_AND_EVALS = gql`
  mutation DeleteReviewAndConnectedEvaluations($reviewId: String!) {
    deleteReviewAndConnectedEvaluations(reviewId: $reviewId)
  }
`;

export const COMPLETE_REVIEW = gql`
  mutation CompleteReview($reviewId: String!) {
    completeReview(reviewId: $reviewId)
  }
`;

export const REOPEN_REVIEW = gql`
  mutation ReopenReview($reviewId: String!) {
    reopenReview(reviewId: $reviewId)
  }
`;